var React = require('react');

function Vue (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M14.5537 8H10L18.3224 23L26 8H21.7076L18.3224 15.3237L14.5537 8Z","fill":"#5B59FB","fillOpacity":"0.4","key":0}),React.createElement("path",{"d":"M10 8H4L18.3415 32L32 8H26L18.3415 22.4L10 8Z","fill":"#5B59FB","key":1})]);
}

Vue.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = Vue;

Vue.default = Vue;
